import { useMutation } from '@tanstack/react-query';
import Api from '../api/Api';
import { MUTATION_KEYS } from './queryKeys';

interface CreateOrderParams {
  shoppingCardDetails: string;
  fileFormats: string;
  extractionRequestIds: Array<string>;
  billingAddress: string;
  isDisplayLocation: boolean;
}

interface CreateOrderResult {
  paymentUrl?: string;
  orderId?: string;
}

export default function usePostCreateOrder() {
  return useMutation({
    mutationKey: [MUTATION_KEYS.cart.createOrder],
    mutationFn: async ({
      shoppingCardDetails,
      fileFormats,
      extractionRequestIds,
      billingAddress,
      isDisplayLocation,
    }: CreateOrderParams): Promise<CreateOrderResult> => {
      const response = await Api.moodV2Order.createOrder(
        shoppingCardDetails,
        fileFormats,
        extractionRequestIds,
        billingAddress,
        isDisplayLocation
      );

      if (response.Error) {
        throw new Error(
          response.Error.ErrorMessage || 'Failed to create order'
        );
      }

      return response.Result || {};
    },
  });
}
